const SearchFiltersSkeleton = () => {
  return (
    <div className="ui-animate-pulse ui-sticky ui-z-[9999999999] md:ui-z-10 ui-flex ui-flex-col ui-top-2 ui-bg-white ui-rounded srp__col-right --desktop">
      <div className="ui-sticky ui-top-0">
        <div className="ui-flex ui-flex-col ui-justify-between">
          <div className="ui-flex ui-items-center ui-justify-between ui-py-4 ui-px-6 ui-bg-gray-100 md:ui-bg-transparent ui-border-solid ui-border-0 ui-border-b ui-border-gray-300 md:ui-border-gray-200 ui-w-px-232 ui-w-px-28 ui-bg-gray-200">
            <div className="ui-h-5 ui-w-20 ui-bg-gray-200 ui-rounded" />{' '}
          </div>
        </div>
        <div className="ui-flex-1 ui-px-6 ui-py-6 ui-mb-px">
          <div className="ui-pb-4 ui-border-solid ui-border-0 ui-border-b ui-border-gray-300">
            <div className="ui-flex">
              <div className="ui-flex ui-w-full ui-justify-between">
                <div className="ui-h-5 ui-w-20 ui-bg-gray-200 ui-rounded" />{' '}
                <div className="ui-border-none ui-flex ui-items-center ui-h-5 ui-w-5 ui-bg-gray-200 ui-rounded-lg" />{' '}
              </div>
            </div>
          </div>
          <div className="ui-pb-4 ui-mt-4 ui-border-solid ui-border-0 ui-border-b ui-border-gray-300">
            <div>
              <button className="ui-w-full ui-max-w-none ui-flex ui-items-center ui-justify-between !ui-leading-tight ui-border-0 ui-bg-transparent !ui-rounded-none focus:ui-outline-none focus:!ui-ring-0 ui-select-none">
                <div className="ui-h-5 ui-w-20 ui-bg-gray-200 ui-rounded" />{' '}
                <div className="ui-border-none ui-flex ui-items-center ui-h-2 ui-w-5 ui-bg-gray-200 ui-rounded" />{' '}
              </button>
            </div>
            <div>
              <div>
                <div className="ui-mt-5">
                  <div className="ui-flex ui-items-center ui-gap-4">
                    <div className="ui-flex-1 ui-ml-3">
                      <div className="ui-flex ui-items-center ui-gap-0.5 ui-py-1.5 ui-text-sm">
                        <span className="ui-h-4 ui-w-20 ui-bg-gray-200 ui-rounded" />{' '}
                      </div>
                    </div>
                    <span className="ui-text-xs ui-text-gray-500 ui-h-4 ui-w-10 ui-bg-gray-200 ui-rounded" />{' '}
                  </div>
                  <div className="ui-flex ui-items-center ui-gap-4">
                    <div className="ui-flex-1 ui-ml-3">
                      <div className="ui-flex ui-items-center ui-gap-0.5 ui-py-1.5 ui-text-sm">
                        <span className="ui-h-4 ui-w-20 ui-bg-gray-200 ui-rounded" />{' '}
                      </div>
                    </div>
                    <span className="ui-text-xs ui-text-gray-500 ui-h-4 ui-w-10 ui-bg-gray-200 ui-rounded" />{' '}
                  </div>
                  <div className="ui-flex ui-items-center ui-gap-4">
                    <div className="ui-flex-1 ui-ml-3">
                      <div className="ui-flex ui-items-center ui-gap-0.5 ui-py-1.5 ui-text-sm">
                        <span className="ui-h-4 ui-w-20 ui-bg-gray-200 ui-rounded" />{' '}
                      </div>
                    </div>
                    <span className="ui-text-xs ui-text-gray-500 ui-h-4 ui-w-10 ui-bg-gray-200 ui-rounded" />{' '}
                  </div>
                  <div className="ui-flex ui-items-center ui-gap-4">
                    <div className="ui-flex-1 ui-ml-3">
                      <div className="ui-flex ui-items-center ui-gap-0.5 ui-py-1.5 ui-text-sm">
                        <span className="ui-h-4 ui-w-20 ui-bg-gray-200 ui-rounded" />{' '}
                      </div>
                    </div>
                    <span className="ui-text-xs ui-text-gray-500 ui-h-4 ui-w-10 ui-bg-gray-200 ui-rounded" />{' '}
                  </div>
                  <div className="ui-flex ui-items-center ui-gap-4">
                    <div className="ui-flex-1 ui-ml-3">
                      <div className="ui-flex ui-items-center ui-gap-0.5 ui-py-1.5 ui-text-sm">
                        <span className="ui-h-4 ui-w-20 ui-bg-gray-200 ui-rounded" />{' '}
                      </div>
                    </div>
                    <span className="ui-text-xs ui-text-gray-500 ui-h-4 ui-w-10 ui-bg-gray-200 ui-rounded" />{' '}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchFiltersSkeleton;
